import React from 'react';
import PropTypes from 'prop-types';
import { FacebookShareButton, TwitterShareButton, LinkedinShareButton, GooglePlusShareButton, EmailShareButton } from 'react-share';
import './styles.scss';

class ShareThis extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.setHoverRef = this.setHoverRef.bind(this);
    this.showPopup = this.showPopup.bind(this);
    this.hidePopup = this.hidePopup.bind(this);
  }

  componentDidMount() {

  }

  componentWillUnmount() {
    if (this.hoverRef) {
      this.hoverRef.removeEventListener('mouseenter', this.showPopup);
      this.hoverRef.removeEventListener('mouseleave', this.hidePopup);
    }
  }

  setHoverRef(node) {
    this.hoverRef = node;
    if (this.hoverRef) {
      this.hoverRef.addEventListener('mouseenter', this.showPopup);
      this.hoverRef.addEventListener('mouseleave', this.hidePopup);
    }
  }

  showPopup() {
    this.setState({
      show: true,
    });
  }

  hidePopup() {
    this.setState({
      show: false,
    });
  }

  render() {
    const { show } = this.state;
    const shareUrl = window.location.href;
    return (
      <div className="share-this-container" ref={this.setHoverRef}>
        { this.props.children }
        {
          show &&
          <div className="share-this-popup">
            <ul>
              <li className="d-none d-md-inline-block"><FacebookShareButton url={shareUrl}><i className="fab fa-facebook-f link-pointer" /></FacebookShareButton></li>
              <li className="d-none d-md-inline-block"><TwitterShareButton url={shareUrl}><i className="fab fa-twitter link-pointer" /></TwitterShareButton></li>
              <li className="d-none d-md-inline-block"><GooglePlusShareButton url={shareUrl}><i className="fab fa-google link-pointer" /></GooglePlusShareButton></li>
              <li className="d-none d-md-inline-block"><LinkedinShareButton url={shareUrl}><i className="fab fa-linkedin-in link-pointer" /></LinkedinShareButton></li>
              <li className="d-none d-md-inline-block"><EmailShareButton url={shareUrl}><i className="far fa-envelope link-pointer" /></EmailShareButton></li>
            </ul>
            <div className="arrow-down" />
          </div>
        }
      </div>
    );
  }
}

ShareThis.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ShareThis;



// WEBPACK FOOTER //
// ./src/components/ShareThis/index.js